import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.join.js";
import { formatDate, monthDifference } from '@applyboard/ui-utils';
import { isAfter, differenceInDays, format } from 'date-fns';
var SourceOfDateLabel = /*#__PURE__*/function (SourceOfDateLabel) {
  SourceOfDateLabel["email"] = "Email";
  SourceOfDateLabel["phone"] = "Phone";
  SourceOfDateLabel["intake_scraper"] = "Intake Scraper";
  SourceOfDateLabel["manual_check"] = "Manual Check";
  SourceOfDateLabel["new_program_for_active_school"] = "New Program for Active School";
  SourceOfDateLabel["submission_notification"] = "Submission Notification";
  SourceOfDateLabel["school_website"] = "School Website";
  SourceOfDateLabel["start_date_level_check"] = "Start Date Level Check";
  return SourceOfDateLabel;
}(SourceOfDateLabel || {});
var IntakeStatusDescription = /*#__PURE__*/function (IntakeStatusDescription) {
  IntakeStatusDescription["open"] = "Based on your profile information, the school is currently accepting applications for this intake. The school has been accepting applications for this intake since ";
  IntakeStatusDescription["open_conditionally"] = "Based on your profile information, the school is currently accepting applications for this intake. The school has been accepting applications for this intake since ";
  IntakeStatusDescription["will_open"] = "Based on your profile information, the school will start accepting applications for this intake on ";
  IntakeStatusDescription["will_open_conditionally"] = "Based on your profile information, the school will start accepting applications for this intake on ";
  IntakeStatusDescription["closed"] = "Based on your profile information, the submission deadline of this intake was SUBMISSION_DEADLINE, which is already passed.";
  IntakeStatusDescription["closed_conditionally"] = "Based on your profile information, the submission deadline of this intake was SUBMISSION_DEADLINE, which is already passed.";
  IntakeStatusDescription["likely_open"] = "The date in which the school starts accepting applications for this intake is still unknown";
  IntakeStatusDescription["submission_deadline"] = "Based on your profile information, the submission deadline of this intake is ";
  IntakeStatusDescription["waitlist"] = "The School has waitlisted this program intake but is still accepting applications.\n\nThere is no guarantee that the application will be processed but fees will still apply.";
  return IntakeStatusDescription;
}(IntakeStatusDescription || {});
var IntakeStatusLabelMapping = /*#__PURE__*/function (IntakeStatusLabelMapping) {
  IntakeStatusLabelMapping["open"] = "Open Now";
  IntakeStatusLabelMapping["open_conditionally"] = "Open Now";
  IntakeStatusLabelMapping["will_open"] = "Will Open";
  IntakeStatusLabelMapping["will_open_conditionally"] = "Will Open";
  IntakeStatusLabelMapping["closed"] = "Closed";
  IntakeStatusLabelMapping["closed_conditionally"] = "Closed";
  IntakeStatusLabelMapping["likely_open"] = "Likely Open";
  IntakeStatusLabelMapping["waitlist"] = "Waitlist";
  return IntakeStatusLabelMapping;
}(IntakeStatusLabelMapping || {});
export function getIntakeStatusText(status) {
  return IntakeStatusLabelMapping[status];
}
export function getIntakeStatusColor(status) {
  var statusMapping = {
    open: '#00ea86',
    open_conditionally: '#00ea86',
    will_open: '#36B37E',
    will_open_conditionally: '#36B37E',
    closed: '#FC8888',
    closed_conditionally: '#FC8888',
    likely_open: '#ffc179',
    waitlist: '#f29b3f'
  };
  return statusMapping[status];
}
export var formatDeadline = function formatDeadline(deadline) {
  if (!deadline) {
    return undefined;
  }
  var today = new Date();
  var submissionDeadlineDate = new Date(deadline);
  return isAfter(submissionDeadlineDate, today) && differenceInDays(submissionDeadlineDate, today) <= 3 ? format(submissionDeadlineDate, 'MMM dd, yyyy, hh:mma, O') : format(submissionDeadlineDate, 'MMM dd, yyyy');
};

// TODO: potentially extract these higher up in the codebase - these are only used by ApplicationIntake AND ChangeProgramIntakeModal
export var isEslGapValid = function isEslGapValid(_ref) {
  var esl = _ref.esl,
    application = _ref.application,
    option = _ref.option;
  if (!application.programEsl) {
    return true;
  }
  var eslProgramMinLength = application.programEsl.minLength;
  if (!option) return true;

  // This is used to compare with the current selected option
  var comparedIntake = esl ? application.intake : application.intakeEsl;
  if (!comparedIntake) return true;
  var diff = monthDifference(option, comparedIntake);
  return esl && diff <= (-eslProgramMinLength || 0) || !esl && diff >= (eslProgramMinLength || 0);
};
export var getMinEslGapRespectedOptions = function getMinEslGapRespectedOptions(_ref2) {
  var esl = _ref2.esl,
    application = _ref2.application,
    options = _ref2.options;
  /**
   * Whenever ESL or Academic intake selection changes, the options for both dropdown
   * will be refreshed w.r.t its program's esl min length.
   */
  return options.filter(
  // Filtering invalid intakes (i.e. Not respects program esl min length).
  function (option) {
    return isEslGapValid({
      esl: esl,
      application: application,
      option: option.value
    });
  });
};
export function getSelectedIntake(_ref3) {
  var intake = _ref3.intake,
    intakes = _ref3.intakes;
  return intakes.find(function (currIntake) {
    return currIntake.startDate === intake;
  });
}
export function generateIntakeTooltip(_ref4) {
  var isEsl = _ref4.isEsl,
    selectedIntake = _ref4.selectedIntake,
    academicSubmissionDeadline = _ref4.academicSubmissionDeadline,
    eslSubmissionDeadline = _ref4.eslSubmissionDeadline,
    isApplicationPaid = _ref4.isApplicationPaid,
    applicationIntakeId = _ref4.applicationIntakeId,
    applicationEslIntakeId = _ref4.applicationEslIntakeId;
  var deadlineExceptionData = selectedIntake.specificDeadlineExceptions && selectedIntake.specificDeadlineExceptions[0];
  var openDateExceptionData = selectedIntake.specificOpendateExceptions && selectedIntake.specificOpendateExceptions[0];
  var newAppException = selectedIntake.specificAcceptingNewAppsExceptions;
  var intakeHasOpenDateException = Array.isArray(openDateExceptionData) && openDateExceptionData.length > 0;
  var sourceDeadline = (deadlineExceptionData === null || deadlineExceptionData === void 0 ? void 0 : deadlineExceptionData.length) > 1 ? deadlineExceptionData[1] : selectedIntake.submissionDeadlineSourceOfDate;
  var confirmedDeadline = (deadlineExceptionData === null || deadlineExceptionData === void 0 ? void 0 : deadlineExceptionData.length) > 1 ? deadlineExceptionData[2] : selectedIntake.submissionDeadlineConfirmedAt && formatDate(selectedIntake.submissionDeadlineConfirmedAt, 'MMM DD, YYYY');
  var sourceOpenDate = intakeHasOpenDateException && (openDateExceptionData === null || openDateExceptionData === void 0 ? void 0 : openDateExceptionData.length) > 1 ? openDateExceptionData[1] : selectedIntake.openDateSourceOfDate;
  var confirmedOpenDate = intakeHasOpenDateException && (openDateExceptionData === null || openDateExceptionData === void 0 ? void 0 : openDateExceptionData.length) > 1 ? openDateExceptionData[2] : selectedIntake.opendateConfirmedAt && formatDate(selectedIntake.opendateConfirmedAt, 'MMM DD, YYYY');
  var openDate = intakeHasOpenDateException ? openDateExceptionData[0] : selectedIntake.openDate && formatDate(selectedIntake.openDate, 'MMM DD, YYYY');
  var submissionDeadline = formatDeadline(isEsl ? eslSubmissionDeadline : academicSubmissionDeadline);
  return generateIntakeTooltipText({
    intakeSpecificStatus: selectedIntake.specificStatus,
    sourceDeadline: sourceDeadline,
    confirmedDeadline: confirmedDeadline,
    submissionDeadline: submissionDeadline,
    openDate: openDate,
    sourceOpenDate: sourceOpenDate,
    confirmedOpenDate: confirmedOpenDate,
    selectedIntake: selectedIntake,
    isApplicationPaid: isApplicationPaid,
    newAppException: newAppException,
    isEsl: isEsl,
    applicationIntakeId: applicationIntakeId,
    applicationEslIntakeId: applicationEslIntakeId
  });
}
export function generateIntakeTooltipText(_ref5) {
  var intakeSpecificStatus = _ref5.intakeSpecificStatus,
    confirmedDeadline = _ref5.confirmedDeadline,
    sourceDeadline = _ref5.sourceDeadline,
    submissionDeadline = _ref5.submissionDeadline,
    openDate = _ref5.openDate,
    sourceOpenDate = _ref5.sourceOpenDate,
    confirmedOpenDate = _ref5.confirmedOpenDate,
    selectedIntake = _ref5.selectedIntake,
    isApplicationPaid = _ref5.isApplicationPaid,
    newAppException = _ref5.newAppException,
    isEsl = _ref5.isEsl,
    applicationIntakeId = _ref5.applicationIntakeId,
    applicationEslIntakeId = _ref5.applicationEslIntakeId;
  if (intakeSpecificStatus === 'waitlist') {
    var baseText = IntakeStatusDescription[intakeSpecificStatus];
    if (submissionDeadline && sourceDeadline && confirmedDeadline) {
      return "".concat(baseText, "\n\n").concat(IntakeStatusDescription.submission_deadline).concat(submissionDeadline, " (Source: ").concat(SourceOfDateLabel[sourceDeadline], " - Confirmation Date: ").concat(confirmedDeadline, ")");
    } else if (submissionDeadline && sourceDeadline) {
      return "".concat(baseText, "\n\n").concat(IntakeStatusDescription.submission_deadline).concat(submissionDeadline, " (Source: ").concat(SourceOfDateLabel[sourceDeadline], ")");
    } else if (submissionDeadline) {
      return "".concat(baseText, "\n\n").concat(IntakeStatusDescription.submission_deadline).concat(submissionDeadline);
    }
    return baseText;
  }

  // TBD scenario - the user just selected a new intake
  if (!submissionDeadline || isEsl && Number(selectedIntake === null || selectedIntake === void 0 ? void 0 : selectedIntake.id) !== applicationEslIntakeId || !isEsl && Number(selectedIntake === null || selectedIntake === void 0 ? void 0 : selectedIntake.id) !== applicationIntakeId) {
    return 'We’re not able to calculate deadline at the moment. Please check later.';
  }
  var intakeInfoTooltip = IntakeStatusDescription[intakeSpecificStatus];
  if (intakeSpecificStatus !== null && intakeSpecificStatus !== void 0 && intakeSpecificStatus.includes('open') && intakeSpecificStatus !== 'likely_open') {
    intakeInfoTooltip += openDate;
    if (sourceOpenDate) {
      intakeInfoTooltip += " (Source: ".concat(SourceOfDateLabel[sourceOpenDate]);
      intakeInfoTooltip += confirmedOpenDate ? " - Confirmation Date: ".concat(confirmedOpenDate, ")") : ')';
    }
    if (submissionDeadline) {
      intakeInfoTooltip += "\n\n".concat(IntakeStatusDescription.submission_deadline).concat(submissionDeadline);
      if (sourceDeadline) {
        intakeInfoTooltip += " (Source: ".concat(SourceOfDateLabel[sourceDeadline]);
        intakeInfoTooltip += confirmedDeadline ? " - Confirmation Date: ".concat(confirmedDeadline, ")") : ')';
      }
    }
    return intakeInfoTooltip;
  }
  if (intakeSpecificStatus !== null && intakeSpecificStatus !== void 0 && intakeSpecificStatus.includes('closed')) {
    if (!(selectedIntake !== null && selectedIntake !== void 0 && selectedIntake.available)) {
      intakeInfoTooltip = 'This intake is closed to all applications for all students';
    } else if (!selectedIntake.acceptingNewApps && !isApplicationPaid || Array.isArray(newAppException) && newAppException.length > 0) {
      intakeInfoTooltip = 'Based on your profile information, this intake is currently unavailable';
    } else {
      var tooltipArr = intakeInfoTooltip.split('SUBMISSION_DEADLINE');
      tooltipArr.splice(1, 0, submissionDeadline);
      intakeInfoTooltip = tooltipArr.join('');
      if (sourceDeadline) {
        intakeInfoTooltip += " (Source: ".concat(SourceOfDateLabel[sourceDeadline]);
        intakeInfoTooltip += confirmedDeadline ? " - Confirmation Date: ".concat(confirmedDeadline, ")") : ')';
      }
    }
    return intakeInfoTooltip;
  }
  if (intakeSpecificStatus !== null && intakeSpecificStatus !== void 0 && intakeSpecificStatus.includes('likely_open')) {
    if (submissionDeadline) {
      intakeInfoTooltip += "\n\n".concat(IntakeStatusDescription.submission_deadline).concat(submissionDeadline);
      if (sourceDeadline) {
        intakeInfoTooltip += " (Source: ".concat(SourceOfDateLabel[sourceDeadline]);
        intakeInfoTooltip += confirmedDeadline ? " - Confirmation Date: ".concat(confirmedDeadline, ")") : ')';
      }
    }
    return intakeInfoTooltip;
  }
  return intakeInfoTooltip;
}